export default __webpack_public_path__ + "static/governance-fe7f5538be219dcebe664afa424c9630.png";